<template>
  <div>
    <!-- 工具栏 -->
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>


      </div>
      <el-button type="primary" size="small" @click="handleAddAppReportCategoryDialog">新建举报原因</el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column prop="appReportCategoryId" label="#" align="center"></el-table-column>
      <el-table-column prop="name" label="类型名称" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
        <template #default="scope">{{ scope.row.createTime | formatDateTime }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="删除时间" align="center">
        <template #default="scope">{{ scope.row.deleteTime | formatDateTime }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button size="small" type="primary" @click="handleEditAppReportCategoryDialog(scope.row)">编辑</el-button>
          <el-button size="small" @click="handleDeleteAppReportCategory(scope.row)"
                     :type="scope.row.deleted ? 'warning' : 'danger'">
            {{ scope.row.deleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="curPageChange"/>

    <el-dialog :title="editType === 'create' ? '新建举报原因':'编辑举报原因' "
               :visible.sync="editAppReportCategoryDialog">
      <el-form ref="form" :model="editAppReportCategoryForm" label-width="80px">
        <el-form-item label="类型名称" required>
          <el-input v-model="editAppReportCategoryForm.name"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editAppReportCategoryDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="() => submitEdit()">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addAppReportCategory,
  getAppReportCategoryList,
  updateAppReportCategory,
  appReportCategoryDeleteOrBack
} from "@/api/AppReport/AppReport";
import {handleRes} from "@/utils/handleRes";
import {deepClone} from "@/utils";

export default {
  name: "AppReportCategoryList",
  data() {
    return {
      loading: false, // 加载开关
      tableData: [], //
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      searchValue: "",
      editAppReportCategoryDialog: false,
      editAppReportCategoryForm: {},
      editType: ""
    }
  },
  created() {
    this.getAppReportCategoryList()
  },
  methods: {
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.currentPage = 1
      this.getAppReportCategoryList()
    },
    curPageChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.getAppReportCategoryList()
    },
    /**
     * 调用接口，分页获取举报原因列表
     */
    getAppReportCategoryList() {
      let params = {
        sortName: "",
        sortOrder: "",
        pageNumber: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        keyWord: this.searchValue,
      }
      getAppReportCategoryList(params).then(res => {
        handleRes(res, () => {
          this.pageOpt.totalCount = res.data.total
          this.tableData = res.data.rows
        })
      })
    },
    /**
     * 调用接口，删除/恢复 举报原因
     * @param entity
     */
    handleDeleteAppReportCategory(entity) {
      appReportCategoryDeleteOrBack({appReportCategoryId: entity.appReportCategoryId}).then(res => {
        handleRes(res, () => {
          this.getAppReportCategoryList()
        })
      })
    },
    handleAddAppReportCategoryDialog() {
      this.editType = 'create'
      this.editAppReportCategoryForm = {}
      this.editAppReportCategoryDialog = true
    },
    /**
     * 调用接口添加举报原因
     */
    addAppReportCategory() {
      addAppReportCategory(this.editAppReportCategoryForm).then(res => {
        handleRes(res, () => {
          this.refreshList()
        })
      })
    },
    submitEdit() {
      if (this.editType === 'create') {
        this.addAppReportCategory()
      } else if (this.editType === 'edit') {
        this.updateAppReportCategory()
      }
      this.editAppReportCategoryDialog = false;
    },
    handleEditAppReportCategoryDialog(entity) {
      this.editType = 'edit'
      this.editAppReportCategoryForm = deepClone(entity)
      this.editAppReportCategoryDialog = true
    },
    /**
     * 调用接口更新举报原因
     */
    updateAppReportCategory() {
      updateAppReportCategory(this.editAppReportCategoryForm).then(res => {
        handleRes(res, () => {
          this.getAppReportCategoryList()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>